import React from 'react'
import Slider from '../slider'
import round from 'lodash/round'
import { WeightSlider } from '../../utils/slider-configs'

const CaratWeightSlider = (props) => {
  const EXPONENT = 2

  const valToPos = val => Math.pow(val, 1 / EXPONENT)

  const posToVal = position => {
    const raw = Math.pow(position, EXPONENT)
    const rounded = round(raw, 2)
    if (rounded === 9.99) return 10 // dear math, be more beautiful
    return rounded
  }

  return (
    <Slider
      double
      inputs
      labelRight='ct'
      min={WeightSlider.min}
      max={WeightSlider.max}
      step={WeightSlider.step}
      minDistance={WeightSlider.minDistance}
      value={props.value}
      onChange={props.onChange}
      mapValues={{
        valToPos,
        posToVal
      }}
    />
  )
}

export default CaratWeightSlider



// WEBPACK FOOTER //
// ./src/components/carat-weight-slider/index.js